var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from 'react';
import { TextButton, Text, Headline } from '@oneaudi/unified-web-components';
import { SYS_SPACE_FIXED_300, SYS_SPACE_RELATIVE_LG } from '@oneaudi/unified-web-common';
import { getProducts, getDefaultProduct } from '../../../../api';
import { useServicesContext, useStockContext } from '../../../../../context';
import { FootnoteReferenceContextProvider } from '../../../../../components';
import { getActiveCampaigns } from '../../../../../components/finance/dynamic-finance/campaign-helper';
import { trackClick, trackUpdateClick } from '../../../../../components/ctaButtons/tracking';
import { useDesktopOrMobileView } from '../../../../../hooks';
import { getFSAGDefaultProduct, patchFormParameter, patchProductData, } from '../../../../utils/crs-helper';
import { saveCampaignInStore, saveProductInStore, readFinance, } from '../../../../utils/sessionStorage';
import { deepCopy } from '../../../../../utils/object';
import { dynamicStylingHelper } from '../../../../utils';
import { useFinance } from '../FinanceContext';
import { prepareDefaultDataForProduct, generateFormData, generateFormSummary, escapeRegExp, getFinancingProductForProductId, generateHeading, getErrorMessage, } from './form-helperRethink';
import { getFormValues } from './form-fieldsRethink';
import { FormWrapper, ReadOnlyGroup, ReadOnlyColumn, HeadingWrapper, FinanceModalWrapper, CTAWrapper, } from './financeModal-stylesRethink';
import { FinanceErrorMessage } from './FinanceErrorMessage';
import { FinanceModalitiesWrapper } from './FinanceModalitiesWrapper';
import { FinanceDisclaimerText } from './FinanceDisclaimerText';
import { FinanceSummaryWrapper } from './FinanceSummaryWrapper';
import { FinanceFormWrapper } from './FinanceFormWrapper';
import { FinanceCashOnlyWrapper } from './FinanceCashOnlyWrapper';
import { useFinanceTranslations } from './finance-i18N';
import FinanceRethinkCTAs from './FinanceRethinkCTAs';
export const FinanceModalRethink = ({ fullVehicle, onClose, onError, setCalculationError, financeData, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { audiMarketContextService, getConfiguration, getEnvironmentConfig } = useServicesContext();
    const { svd } = useStockContext();
    const isMobileScreenSize = useDesktopOrMobileView('688px') === 'mobile';
    const trackingService = useServicesContext().getAdditionalService('audi-tracking-service');
    const footnoteReferenceServiceScopeManager = useServicesContext().getAdditionalService('audi-footnote-reference-service');
    const scopedFootnoteReferenceService = footnoteReferenceServiceScopeManager.getCustomScopeRefService('financeModal');
    const vehicleType = fullVehicle.basic.type;
    const vehicleId = fullVehicle.basic.id;
    const endpointUrl = (_a = getEnvironmentConfig()) === null || _a === void 0 ? void 0 : _a.crsServiceBaseUrl;
    const currency = (_c = (_b = getConfiguration()) === null || _b === void 0 ? void 0 : _b.currency) !== null && _c !== void 0 ? _c : audiMarketContextService === null || audiMarketContextService === void 0 ? void 0 : audiMarketContextService.getContextItem('nemo.locale.currency');
    const currencyPattern = (_e = (_d = getConfiguration()) === null || _d === void 0 ? void 0 : _d.currencyPattern) !== null && _e !== void 0 ? _e : audiMarketContextService === null || audiMarketContextService === void 0 ? void 0 : audiMarketContextService.getContextItem('stockcar.custom.currency.pattern');
    const [webCalcErrorMsg, setWebCalcErrorMsg] = useState('');
    const [loading, setLoading] = useState(false);
    if (!((_f = fullVehicle.detail) === null || _f === void 0 ? void 0 : _f.financingRequest)) {
        return null;
    }
    const productParameter = (financeData === null || financeData === void 0 ? void 0 : financeData.productParameter) || {};
    const formParameter = (financeData === null || financeData === void 0 ? void 0 : financeData.formParameter) || {};
    const financeCampaign = (financeData === null || financeData === void 0 ? void 0 : financeData.campaign) || {};
    const financingProduct = financeCampaign && Object.keys(financeCampaign).length
        ? getFinancingProductForProductId(financeData, vehicleId, financeCampaign.typeDetail)
        : {};
    const requestData = (_g = financeData === null || financeData === void 0 ? void 0 : financeData.vehicleData) === null || _g === void 0 ? void 0 : _g.default;
    const actualDefaultProductID = (_j = (_h = financeData === null || financeData === void 0 ? void 0 : financeData.vehicleData) === null || _h === void 0 ? void 0 : _h.default) === null || _j === void 0 ? void 0 : _j.Product['@ID'];
    const productRequestData = (_k = financeData === null || financeData === void 0 ? void 0 : financeData.vehicleData) === null || _k === void 0 ? void 0 : _k.product;
    const getDynamicProduct = (result) => {
        var _a, _b, _c;
        const summary = Array.isArray(result) && result.length > 0
            ? (_b = (_a = result[0]) === null || _a === void 0 ? void 0 : _a.Summaries) === null || _b === void 0 ? void 0 : _b.Summary
            : (_c = result === null || result === void 0 ? void 0 : result.Summaries) === null || _c === void 0 ? void 0 : _c.Summary;
        const fullSummary = summary === null || summary === void 0 ? void 0 : summary.find((item) => item['@Type'] === 'Full');
        const dymanicProduct = (fullSummary === null || fullSummary === void 0 ? void 0 : fullSummary.Title['#text'])
            ? fullSummary === null || fullSummary === void 0 ? void 0 : fullSummary.Title['#text']
            : fullSummary === null || fullSummary === void 0 ? void 0 : fullSummary.Title;
        return dymanicProduct;
    };
    let initialDefaultProductData;
    if (financeData && Object.keys(financeData === null || financeData === void 0 ? void 0 : financeData.defaultProductData).length > 0) {
        initialDefaultProductData = financeData === null || financeData === void 0 ? void 0 : financeData.defaultProductData;
    }
    else {
        initialDefaultProductData = Array.isArray(requestData === null || requestData === void 0 ? void 0 : requestData.Product)
            ? Object.assign({}, requestData === null || requestData === void 0 ? void 0 : requestData.Product[0]) : Object.assign({}, requestData === null || requestData === void 0 ? void 0 : requestData.Product);
    }
    const [productData, setProductData] = useState(requestData === null || requestData === void 0 ? void 0 : requestData.Product);
    const [rawProduct, setRawProduct] = useState();
    const [defaultProductData, setDefaultProductData] = useState(initialDefaultProductData);
    const [formData, setFormData] = useState(null);
    const [formSummaryData, setFormSummaryData] = useState(null);
    const [loadedFinanceData, setLoadedFinanceData] = useState(false);
    const [inputFields, setInputFields] = useState({});
    const [showUpdateButton, setShowUpdateButton] = useState(false);
    const [dynamicHeadlineProduct, setDynamicHeadlineProduct] = useState(null);
    const [intialSetup, setIntialSetup] = useState(false);
    const [isProductChanged, setIsProductChanged] = useState(false);
    const { selectedModalityInContext, setModalityInContext } = useFinance();
    const [selectedModality, setSelectedModality] = useState(undefined);
    const i18n = useFinanceTranslations();
    useEffect(() => {
        loadProductData();
    }, [defaultProductData]);
    useEffect(() => {
        setSelectedModality(selectedModalityInContext === 'Cash'
            ? selectedModalityInContext
            : defaultProductData['@Type']);
    }, []);
    const fetchSummary = () => {
        var _a, _b, _c, _d;
        const financeDataFromStore = readFinance((_a = fullVehicle === null || fullVehicle === void 0 ? void 0 : fullVehicle.basic) === null || _a === void 0 ? void 0 : _a.type);
        const financeResponseData = ((_b = financeDataFromStore === null || financeDataFromStore === void 0 ? void 0 : financeDataFromStore.financing[vehicleId]) === null || _b === void 0 ? void 0 : _b.financeResponseData)
            ? (_c = financeDataFromStore === null || financeDataFromStore === void 0 ? void 0 : financeDataFromStore.financing[vehicleId]) === null || _c === void 0 ? void 0 : _c.financeResponseData
            : (_d = financeDataFromStore === null || financeDataFromStore === void 0 ? void 0 : financeDataFromStore.financing[vehicleId]) === null || _d === void 0 ? void 0 : _d.defaultResponse;
        const generatedFormSummary = generateFormSummary(financeResponseData === null || financeResponseData === void 0 ? void 0 : financeResponseData.Response, currency, currencyPattern);
        setFormSummaryData(generatedFormSummary);
    };
    useEffect(() => {
        if (formData && !intialSetup) {
            calculate();
            setIntialSetup(true);
        }
    }, [formData, intialSetup]);
    const setFormValue = (formName, field, value) => {
        const data = Object.assign({}, inputFields);
        data[formName][field.id] = field.control.dataType === 'decimal' ? parseFloat(value) : value;
        setInputFields(data);
    };
    const loadProductData = () => __awaiter(void 0, void 0, void 0, function* () {
        let defaultRawData;
        try {
            if (defaultProductData['@ID'] === (financeData === null || financeData === void 0 ? void 0 : financeData.defaultProductData['@ID']) &&
                (financeData === null || financeData === void 0 ? void 0 : financeData.defaultResponse.Response) &&
                !isProductChanged) {
                defaultRawData = Object.assign({}, financeData === null || financeData === void 0 ? void 0 : financeData.defaultResponse.Response);
            }
            else {
                defaultRawData = yield getDefaultProduct(endpointUrl, Object.assign(Object.assign({}, requestData), {
                    Product: { '@ID': defaultProductData['@ID'] },
                }), fullVehicle.basic.id, vehicleType, trackingService, false);
            }
            const defaultDataForProduct = prepareDefaultDataForProduct(defaultRawData);
            const generatedFormData = generateFormData(defaultDataForProduct.Parameters, currency, currencyPattern);
            setInputFields(getFormValues(generatedFormData));
            setFormData(generatedFormData);
            setRawProduct(defaultRawData);
            setDynamicHeadlineProduct(getDynamicProduct(defaultRawData.Result));
            fetchSummary();
        }
        catch (error) {
            onError(getErrorMessage(error, i18n));
        }
    });
    const loadFinanceData = () => __awaiter(void 0, void 0, void 0, function* () {
        var _l;
        let productDataInsideFn = productData;
        try {
            setLoadedFinanceData(true);
            if (productRequestData) {
                const products = yield getProducts(endpointUrl, (_l = fullVehicle.detail.financingProductsRequest) === null || _l === void 0 ? void 0 : _l.Request, fullVehicle.basic.id, vehicleType, trackingService, false);
                productDataInsideFn = products.Products.Product;
                let defaultProduct = getFSAGDefaultProduct(products);
                const storeDefaultProduct = financeData === null || financeData === void 0 ? void 0 : financeData.defaultProductData;
                if (Object.keys(storeDefaultProduct).length > 0) {
                    defaultProduct = storeDefaultProduct;
                }
                if (defaultProduct['@ID'] !== defaultProductData['@ID']) {
                    setDefaultProductData(defaultProduct);
                }
            }
            patchProductData(productDataInsideFn, requestData, productParameter, defaultProductData);
            const patchedFormParameter = patchFormParameter(defaultProductData, formParameter);
            if (patchedFormParameter) {
                setDefaultProductData(patchedFormParameter);
            }
            if (financeCampaign && Object.keys(financeCampaign).length) {
                setDefaultProductData(Object.assign(Object.assign({}, defaultProductData), { '@ID': financeCampaign.typeDetail, '@CampaignID': financeCampaign.campaignId }));
            }
            yield loadProductData();
            if (financeCampaign && Object.keys(financeCampaign).length) {
                productDataInsideFn = yield addCampaignAsProduct(Array.isArray(productDataInsideFn) ? productDataInsideFn : [productDataInsideFn]);
            }
            setProductData(productDataInsideFn);
        }
        catch (error) {
            onError(getErrorMessage(error, i18n));
        }
    });
    const addCampaignAsProduct = (productDataInsideFn) => __awaiter(void 0, void 0, void 0, function* () {
        const vehiclesActiveCampaigns = yield getActiveCampaigns(fullVehicle, getEnvironmentConfig(), svd, getConfiguration());
        if (!vehiclesActiveCampaigns.length) {
            saveCampaignInStore(vehicleId, vehicleType, {});
        }
        let product = financingProduct;
        product = Array.isArray(product) ? product[0] : product;
        if (product && product.Label) {
            vehiclesActiveCampaigns.forEach((campaign_, index) => {
                const financeProduct = deepCopy(product);
                financeProduct.Label = campaign_.filterText;
                financeProduct.value = campaign_.typeDetail;
                financeProduct['@ID'] = `${campaign_.typeDetail}-${campaign_.campaignId}`;
                if (!productParameter || (productParameter && productParameter['@CampaignID'])) {
                    financeProduct['@Default'] =
                        vehiclesActiveCampaigns.length >= 1 &&
                            campaign_.campaignId === financeCampaign.campaignId
                            ? 'Yes'
                            : 'No';
                    if (index === 0) {
                        productDataInsideFn.forEach((prod) => {
                            prod['@Default'] = 'No';
                        });
                    }
                }
                else {
                    productDataInsideFn.forEach((prod) => {
                        prod['@Default'] = 'No';
                    });
                    const currentProduct = productDataInsideFn.filter((prod) => prod['@ID'] === productParameter['@ID']);
                    if (currentProduct.length) {
                        currentProduct[0]['@Default'] = 'Yes';
                    }
                    financeProduct['@Default'] = 'No';
                }
                financeProduct.Campaign = financeCampaign.campaignId;
                productDataInsideFn.push(financeProduct);
            });
        }
        return productDataInsideFn;
    });
    const getFSAGRequestObject = (inputFormValues, currentProductData) => {
        const formValues = Object.values(inputFormValues).reduce((target, form) => {
            return Object.assign(Object.assign({}, target), form);
        }, {});
        const mappedFormValues = Object.keys(formValues)
            .filter((key) => !key.startsWith('$'))
            .map((fieldId) => {
            return {
                '@ID': fieldId,
                '#text': typeof formValues[fieldId] === 'number'
                    ? formValues[fieldId]
                    : escapeRegExp(formValues[fieldId]),
            };
        });
        const product = { '@ID': currentProductData['@ID'] };
        const request = Object.assign(Object.assign({}, requestData), { Product: Object.assign(Object.assign({}, product), { Parameter: [...mappedFormValues] }) });
        return request;
    };
    const calculate = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        setWebCalcErrorMsg('');
        const formValues = Object.values(inputFields).reduce((target, form) => {
            return Object.assign(Object.assign({}, target), form);
        }, {});
        const useCalcTargets = !!(formValues === null || formValues === void 0 ? void 0 : formValues.CalcTarget);
        const keysUsedWithCalcTarget = new Set(['$Rate', '$DownPayment']);
        const mappedFormValues = Object.keys(formValues)
            .filter((key) => useCalcTargets
            ? keysUsedWithCalcTarget.has(key) || !key.startsWith('$')
            : !key.startsWith('$'))
            .map((fieldId) => {
            return {
                '@ID': useCalcTargets ? fieldId.replace('$', '') : fieldId,
                '#text': typeof formValues[fieldId] === 'number'
                    ? formValues[fieldId]
                    : escapeRegExp(formValues[fieldId]),
            };
        });
        const product = { '@ID': defaultProductData['@ID'] };
        const request = Object.assign(Object.assign({}, requestData), { Product: Object.assign(Object.assign({}, product), { Parameter: [...mappedFormValues] }) });
        try {
            const rawProductFromApi = yield getDefaultProduct(endpointUrl, request, fullVehicle.basic.id, vehicleType, trackingService, false);
            const defaultDataForProduct = prepareDefaultDataForProduct(rawProductFromApi);
            const generatedFormData = generateFormData(defaultDataForProduct.Parameters, currency, currencyPattern);
            if (rawProductFromApi.Error) {
                if (typeof rawProductFromApi.Error.Description === 'object' &&
                    rawProductFromApi.Error.Description !== null) {
                    setWebCalcErrorMsg(rawProductFromApi.Error.Description['#text'] || '');
                }
                else if (typeof rawProductFromApi.Error.Description === 'string') {
                    setWebCalcErrorMsg(rawProductFromApi.Error.Description || '');
                }
                setCalculationError(true);
            }
            else {
                setInputFields(getFormValues(generatedFormData));
                setFormData(generatedFormData);
                fetchSummary();
                setRawProduct(rawProductFromApi);
                setLoading(false);
                setDynamicHeadlineProduct(getDynamicProduct(rawProductFromApi.Result));
                setCalculationError(false);
                setIsProductChanged(false);
            }
        }
        catch (error) {
            const errorMsg = getErrorMessage(error, i18n);
            setWebCalcErrorMsg(errorMsg);
            setLoading(false);
            setCalculationError(true);
        }
        setShowUpdateButton(true);
    });
    const update = (closeModal, trackUpdate = false) => {
        saveProductInStore(vehicleId, vehicleType, rawProduct, defaultProductData);
        setModalityInContext(selectedModality);
        if (trackUpdate)
            trackUpdateClick(trackingService, i18n === null || i18n === void 0 ? void 0 : i18n.updateButton);
        if (closeModal) {
            if (webCalcErrorMsg) {
                resetFormOnClick();
            }
            onClose();
        }
    };
    if (!loadedFinanceData) {
        loadFinanceData();
        return null;
    }
    const resetFormOnClick = () => {
        setWebCalcErrorMsg('');
        loadProductData();
    };
    const fsagRequest = getFSAGRequestObject(inputFields, defaultProductData);
    const trackButtonClick = (button, variant, trackingCode, btnName) => {
        trackClick(trackingService, button, variant, 'vtp-carInfo', fullVehicle.basic.id, trackingCode, btnName);
    };
    return (React.createElement(FootnoteReferenceContextProvider, { footnoteReferenceServiceScopeManager: footnoteReferenceServiceScopeManager, customScope: scopedFootnoteReferenceService.getConsumerId() },
        React.createElement(FinanceModalWrapper, null,
            React.createElement(HeadingWrapper, null,
                React.createElement(Headline, { tag: "h1", variant: {
                        order: dynamicStylingHelper('3', '1'),
                        type: 'headline',
                        weight: 'normal',
                    } }, generateHeading(fullVehicle.basic.type, selectedModality, dynamicHeadlineProduct, i18n))),
            React.createElement(FinanceModalitiesWrapper, { vehicle: fullVehicle.basic, productData: Array.isArray(productData) ? productData : [productData], defaultProductData: defaultProductData, actualDefaultProductID: actualDefaultProductID, setDefaultProductData: setDefaultProductData, setWebCalcErrorMsg: setWebCalcErrorMsg, setIsProductChanged: setIsProductChanged, selectedModality: selectedModality, setSelectedModality: setSelectedModality }),
            React.createElement("div", null, selectedModality !== 'Cash' ? (React.createElement(React.Fragment, null,
                React.createElement(Text, { tag: "p", variant: { type: 'copy', order: '1', style: 'bold' }, margin: [0, 0, dynamicStylingHelper(SYS_SPACE_FIXED_300, SYS_SPACE_RELATIVE_LG), 0], key: i18n === null || i18n === void 0 ? void 0 : i18n.formHeadline, className: "default-color-text" }, i18n === null || i18n === void 0 ? void 0 : i18n.formHeadline),
                React.createElement(FormWrapper, null,
                    React.createElement(FinanceFormWrapper, { formData: formData, inputFields: inputFields, setFormValue: setFormValue, calculate: calculate, loading: loading }),
                    React.createElement(ReadOnlyColumn, null,
                        React.createElement(ReadOnlyGroup, null, !webCalcErrorMsg ? (React.createElement(FinanceSummaryWrapper, { formSummaryData: formSummaryData, loading: loading })) : (React.createElement(FinanceErrorMessage, { webCalcErrorMsg: webCalcErrorMsg, resetFormOnClick: resetFormOnClick }))))))) : (React.createElement(FormWrapper, null,
                React.createElement(FinanceCashOnlyWrapper, { vehicleBasic: fullVehicle.basic })))),
            React.createElement(CTAWrapper, { isMobile: isMobileScreenSize },
                React.createElement(FinanceRethinkCTAs, { key: `${defaultProductData['@ID']}-ctas`, vehicle: fullVehicle.basic, selectedModality: selectedModality, useFinanceData: Boolean(true), isLoading: loading, fsagRequest: fsagRequest, hasWebCalcErrors: webCalcErrorMsg.length > 0, isMobileScreenSize: isMobileScreenSize, trackButtonClick: trackButtonClick }),
                showUpdateButton && (React.createElement(TextButton, { variant: "secondary", size: dynamicStylingHelper('md', 'sm'), isFullWidth: isMobileScreenSize, "aria-label": i18n === null || i18n === void 0 ? void 0 : i18n.updateBtn, isLoading: loading, disabled: Boolean(webCalcErrorMsg), onClick: () => {
                        update(true, true);
                    } }, i18n === null || i18n === void 0 ? void 0 : i18n.updateButton)))),
        selectedModality !== 'Cash' && React.createElement(FinanceDisclaimerText, { formData: formData })));
};
